export const AUTH_COOKIE_CSRF_TOKEN = 'csrf_token';
